<script setup lang="ts">
</script>
<template>
  <div class="w-full flex-1 min-h-svh min-h-screen overflow-y-auto">
    <slot name="default" />
  </div>
</template>
